export default __webpack_public_path__ + "static/korok-leaves-a29534fce351df55d34d1e98532e163f.png";